<script async setup>
import { defineProps } from "vue";

const props = defineProps({
    error: {
        type: String,
        default: null,
    },
    inputWrapClass: {
        type: String,
        default: "relative",
    },
    label: {
        type: String,
        default: null,
    },
    labelWrap: {
        type: Boolean,
        default: true,
    },
    required: {
        type: Boolean,
        default: false,
    },
    labelClass: {
        type: String,
        default: ""
    },
});
</script>

<template>
    <component :is="props.labelWrap ? 'label' : 'div'" class="flex-1 relative">
        <div v-if="props.label" :class="['absolute -top-3 left-2 bg-white text-sm z-30', props.labelClass]">
            {{ props.label }}<span v-if="props.required">*</span>
        </div>

        <div :class="props.inputWrapClass">
            <slot />
        </div>

        <p v-if="props.error" class="mt-1 text-sm text-red">
            {{ props.error }}
        </p>
    </component>
</template>
